import {FormattedMessage} from 'react-intl'

function CreateError() {
  return <h1 className='fw-bolder text-dark mb-3'>
    <FormattedMessage id="MODAL.CREATE.ERROR" defaultMessage="Что-то пошло не так." />
  </h1>
}

export {CreateError}
